import { render, staticRenderFns } from "./pondRenewal.vue?vue&type=template&id=18d1cc1e&scoped=true&"
import script from "./pondRenewal.vue?vue&type=script&lang=js&"
export * from "./pondRenewal.vue?vue&type=script&lang=js&"
import style0 from "./pondRenewal.vue?vue&type=style&index=0&id=18d1cc1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d1cc1e",
  null
  
)

export default component.exports